const STORAGE_KEY = 'promptx_api_key';
const LEGACY_STORAGE_KEY = 'promptx_openai_api_key';

export function getStoredApiKey(): string | null {
  const current = localStorage.getItem(STORAGE_KEY);
  if (current) return current;

  const legacy = localStorage.getItem(LEGACY_STORAGE_KEY);
  if (legacy) {
    localStorage.setItem(STORAGE_KEY, legacy);
    localStorage.removeItem(LEGACY_STORAGE_KEY);
    return legacy;
  }

  return null;
}

export function setStoredApiKey(key: string): void {
  localStorage.setItem(STORAGE_KEY, key.trim());
  localStorage.removeItem(LEGACY_STORAGE_KEY);
}

export function clearStoredApiKey(): void {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(LEGACY_STORAGE_KEY);
}

export function maskApiKey(key: string): string {
  if (key.length <= 8) return '••••••••';
  return `${key.slice(0, 3)}••••••••${key.slice(-4)}`;
}
